// eslint-disable-next-line import/prefer-default-export
export const isSelfServicePortalEnabled = () => (
  process.env.GATSBY_SSP_ENABLED && process.env.GATSBY_SSP_ENABLED.toLowerCase() === "true"
);

export const showUserNavigation = (data) => (
  (process.env.GATSBY_SSP_SHOW_USER_NAVIGATION && process.env.GATSBY_SSP_SHOW_USER_NAVIGATION.toLowerCase() === "true")
  || data !== null
);
